/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesAchievementProgressTierSchema } from "./achievementProgressTierSchema.ts";
import { goodLuckCoreEntitiesAchievementRaritySchema } from "./achievementRaritySchema.ts";
import { goodLuckCoreEntitiesUserAchievementSchema } from "./userAchievementSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesAchievementDefinitionSchema = z.object({
  id: z.optional(z.int()),
  name: z.string().min(1).max(100),
  description: z.string().min(1).max(500),
  iconUrl: z.string().min(1),
  iconName: z.string().max(100).nullish(),
  get rarity() {
    return goodLuckCoreEntitiesAchievementRaritySchema.optional();
  },
  unlockConditionDescription: z.string().max(500).nullish(),
  conditionExpressionJson: z.string().nullish(),
  category: z.string().max(50).nullish(),
  get userAchievements() {
    return z.array(goodLuckCoreEntitiesUserAchievementSchema).nullish();
  },
  get progressTiers() {
    return z.array(goodLuckCoreEntitiesAchievementProgressTierSchema).nullish();
  },
});
